"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignerAdapter = void 0;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const ethers = __importStar(require("ethers"));
const core_1 = require("../core");
function ethSigFromRecoverableSig(x) {
    const sig = core_1.SecP256K1.RecoverableSignature.sig(x);
    const recoveryParam = core_1.SecP256K1.RecoverableSignature.recoveryParam(x);
    return ethers.utils.splitSignature(core.compatibleBufferConcat([sig, Buffer.from([recoveryParam])]));
}
class SignerAdapter extends ethers.Signer {
    constructor(isolatedKey, provider) {
        super();
        this._isolatedKey = isolatedKey;
        this.provider = provider;
    }
    static create(isolatedKey, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            return new SignerAdapter(isolatedKey, provider);
        });
    }
    // This throws (as allowed by ethers.Signer) to avoid having to return an object which is initialized asynchronously
    // from a synchronous function. Because all the (other) methods on SignerAdapter are async, one could construct a
    // wrapper that deferred its initialization and awaited it before calling through to a "real" method, but that's
    // a lot of complexity just to implement this one method we don't actually use.
    connect(_provider) {
        throw new Error("changing providers on a SignerAdapter is unsupported");
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return ethers.utils.computeAddress(core_1.SecP256K1.UncompressedPoint.from(yield this._isolatedKey.getPublicKey()));
        });
    }
    signDigest(digest) {
        return __awaiter(this, void 0, void 0, function* () {
            const recoverableSig = yield core_1.SecP256K1.RecoverableSignature.signCanonically(this._isolatedKey, null, digest instanceof Uint8Array ? digest : ethers.utils.arrayify(digest));
            const sig = core_1.SecP256K1.RecoverableSignature.sig(recoverableSig);
            const recoveryParam = core_1.SecP256K1.RecoverableSignature.recoveryParam(recoverableSig);
            return ethers.utils.splitSignature(core.compatibleBufferConcat([sig, Buffer.from([recoveryParam])]));
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = yield ethers.utils.resolveProperties(transaction);
            if (tx.from != null) {
                if (ethers.utils.getAddress(tx.from) !== (yield this.getAddress())) {
                    throw new Error("transaction from address mismatch");
                }
                delete tx.from;
            }
            const unsignedTx = Object.assign(Object.assign({}, tx), { nonce: tx.nonce !== undefined ? ethers.BigNumber.from(tx.nonce).toNumber() : undefined });
            const txBuf = ethers.utils.arrayify(ethers.utils.serializeTransaction(unsignedTx));
            const rawSig = yield core_1.SecP256K1.RecoverableSignature.signCanonically(this._isolatedKey, "keccak256", txBuf);
            return ethers.utils.serializeTransaction(unsignedTx, ethSigFromRecoverableSig(rawSig));
        });
    }
    signMessage(messageData) {
        return __awaiter(this, void 0, void 0, function* () {
            const messageDataBuf = typeof messageData === "string"
                ? Buffer.from(messageData.normalize("NFKD"), "utf8")
                : Buffer.from(ethers.utils.arrayify(messageData));
            const messageBuf = core.compatibleBufferConcat([Buffer.from(`\x19Ethereum Signed Message:\n${messageDataBuf.length}`, "utf8"), messageDataBuf]);
            const rawSig = yield core_1.SecP256K1.RecoverableSignature.signCanonically(this._isolatedKey, "keccak256", messageBuf);
            return ethers.utils.joinSignature(ethSigFromRecoverableSig(rawSig));
        });
    }
}
exports.SignerAdapter = SignerAdapter;
exports.default = SignerAdapter;
